import { render, staticRenderFns } from "./Button.component.vue?vue&type=template&id=225141b1"
import script from "./Button.component.vue?vue&type=script&lang=js"
export * from "./Button.component.vue?vue&type=script&lang=js"
import style0 from "./Button.component.vue?vue&type=style&index=0&id=225141b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports